import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../../../../../components/get-diemensions/UseWindowDiemensions";
import { BlackAndWhite } from "../../../../../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  CloseButton,
  TextAreaInput,
  TextInputField,
} from "../../../../../../../../components/atoms";
import CategorySelector from "../category-select/CategorySelector";

const ManagePromotions = ({
  setClose,
  selectedPromo,
  date,
  auth,
  category,
  setToastPop,
  setMessage,
}) => {
  const { width, height } = useWindowDimensions();

  const [categorySelected, setCategorySelected] = useState(null);

  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState();

  const [loading, setLoading] = useState(false);

  const editPromotionAndSave = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/promotionRoute/editPromotion",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: status,
            category: categorySelected,
            description: description,
            discountAmount: amount,
            promotionName: name,
            existingName: selectedPromo.promotionName,
            staffUserId: auth.userId,
          }),
        }
      );
      const respnseData = await response.json();
      console.log("response", respnseData);
      if (respnseData.success) {
        setClose(null);
        setMessage(respnseData.success);
        setToastPop(true);
        setLoading(false);
      } else {
        setLoading(false);
        setToastPop(true);
        setMessage(respnseData.message);
      }
    } catch (err) {
      setLoading(false);
      setToastPop(true);
      setMessage("no network, please try again later");
      console.log("test", err);
    }
  };

  useEffect(() => {
    if (selectedPromo) {
      setName(selectedPromo.promotionName);
      setStatus(selectedPromo.status);
      setDescription(selectedPromo.description);
      setAmount(selectedPromo.discountAmount);
      setCategorySelected(selectedPromo.category);
    }
  }, [selectedPromo]);
  return (
    <div
      style={{
        position: "fixed",
        top: 60,
        width: width,
        height: height - 60,
        backgroundColor: BlackAndWhite.secondary,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        <CloseButton label={"X"} onClick={() => setClose(null)} />
        <div style={{ marginLeft: 20 }}>MANAGE PROMOTION</div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 60,
          width: 300,
        }}
      >
        <TextInputField
          labelTitle={"Promotion Name"}
          invert={true}
          mini={true}
          onChange={(e) => setName(e.target.value)}
          value={name}
          size={270}
          placeholder={"i.e 2 gh pre-roll"}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 5,
          width: 300,
        }}
      >
        <div
          style={{
            marginTop: 5,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
            width: "100%",
          }}
        >
          Status
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 18,
            // opacity: 0.7,
            width: "100%",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <CheckInput
            question={"ACTIVE"}
            check={status === "Active" ? true : false}
            invert={true}
            mini={true}
            onClick={() => setStatus("Active")}
          />
          <div style={{ minWidth: 20 }} />
          <CheckInput
            question={"INACTIVE"}
            check={status === "Inactive" ? true : false}
            invert={true}
            mini={true}
            onClick={() => setStatus("Inactive")}
          />
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", width: 300 }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          date created
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 18,
            // opacity: 0.7,
          }}
        >
          {selectedPromo
            ? new Date(selectedPromo.createdOn)
                .toLocaleString()
                .substring(0, 17)
            : null}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", width: 300 }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          Category
        </div>
        <CategorySelector
          categoriesArray={category}
          selectedCategory={categorySelected}
          setSelectedCategory={setCategorySelected}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            marginTop: 3,
            // marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 16,
            // opacity: 0.7,
            minHeight: 75,
            overflow: "hidden",
            width: 320,
          }}
        >
          <TextAreaInput
            mini={true}
            labelTitle={"DESCRIPTION"}
            invert={true}
            color={BlackAndWhite.primary}
            size={280}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: 300,
          marginTop: 10,
        }}
      >
        <TextInputField
          mini={true}
          labelTitle={"DISCOUNT AMOUNT"}
          invert={true}
          size={275}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </div>
      <div
        style={{ position: "absolute", top: 10, right: 10, display: "flex" }}
      >
        <BaseButtons
          marginTopFalse={true}
          label={"UPDATE"}
          mini={true}
          marginRight={10}
          height={40}
          onClick={() => editPromotionAndSave()}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              // marginTop: 10,
              // marginLeft: 10,
              fontWeight: "bold",
              fontSize: 12,
              opacity: 0.7,
              width: "100%",
              textAlign: "right",
            }}
          >
            Created by
          </div>
          <div
            style={{
              marginTop: 3,
              // marginLeft: 10,
              fontWeight: "bold",
              fontSize: 14,
              // opacity: 0.7,
              width: "100%",
              textAlign: "right",
            }}
          >
            admin user
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagePromotions;
